module.exports = __webpack_public_path__ + "img/donut_chart.e39a00d8.svg";